import { useContext} from 'react';
import ReportContext, { type ReportProviderContextType } from '../context/ReportProvider';

const useReport = (): ReportProviderContextType => {    
    return useContext(ReportContext);
}

export default useReport;